import React from 'react'
import ReactDOM from 'react-dom'
import Polyglot from 'node-polyglot'
import * as firebase from 'firebase'
import moment from 'moment'
import BigCalendar from 'react-big-calendar'
import 'auth0-js'

import './index.css'

import log4javascript from 'log4javascript'

import './resources/web-fonts-with-css/css/fontawesome-all.css'

import App from './components/general/App/App'

import LOCALE_IT_IT from './resources/locales/it-IT'
import LOCALE_PT_PT from './resources/locales/pt-PT'
import LOCALE_ES_ES from './resources/locales/es-ES'
import LOCALE_FR_FR from './resources/locales/fr-FR'
import LOCALE_EN_GB from './resources/locales/en-GB'

export const storageKey = 'crescendoStorage'
export const languagePreference = 'crescendoLanguage'

const configuration = {
  apiKey: 'AIzaSyDAaXcYnxPfG_VKh1eh1CLnqs79zFFE0bA',
  authDomain: 'cards-configuration.firebaseapp.com',
  databaseURL: 'https://cards-configuration.firebaseio.com',
  projectId: 'cards-configuration',
  storageBucket: 'cards-configuration.appspot.com',
  messagingSenderId: '1057398774537'
}

const data = {
  apiKey: 'AIzaSyDNOM503AXUu5PiMBvXKyon6n5bEJRQMKg',
  authDomain: 'cards-data-c8758.firebaseapp.com',
  databaseURL: 'https://cards-data-c8758.firebaseio.com',
  projectId: 'cards-data-c8758',
  storageBucket: 'cards-data-c8758.appspot.com',
  messagingSenderId: '182800749240'
}

window.myLogger = log4javascript.getDefaultLogger()

if (process.env.NODE_ENV !== 'production') {
  console.log('setting log to console for debug')
  window.myLogger = console
} else {
  // let ajaxAppender = new log4javascript.AjaxAppender('http://localhost:3000/api/logger')
  // let jsonLayout = new log4javascript.JsonLayout()
  // ajaxAppender.setLayout(jsonLayout)
  // window.myLogger.addAppender(ajaxAppender)
  window.myLogger = console
}
//
// window.myLogger = log4javascript.getDefaultLogger()
// // window.myLogger = log4javascript.getLogger();
// let layout = new log4javascript.JsonLayout(true, true)
// layout.returnsPostData = true
// let popUpAppender = new log4javascript.PopUpAppender('http://localhost:3000/api/logger')
// let ajaxAppender = new log4javascript.AjaxAppender('http://localhost:3000/api/logger')
// ajaxAppender.addHeader('Content-Type', 'application/json')
// ajaxAppender.setLayout(layout)
// popUpAppender.setLayout(layout)
// window.myLogger.addAppender(ajaxAppender)
// // report all user console errors
// window.onerror = function (message, url, lineNumber) {
//   let errorMsg = 'Console error - ' + url + ' : ' + lineNumber + ': ' + message
//   window.myLogger.error(errorMsg)
//   return true
// }

// Initialize the default app
firebase.initializeApp(configuration)

let locale = 'pt'

if (window.localStorage.getItem(languagePreference)) {
  locale = window.localStorage.getItem(languagePreference)
}

let polyglot = new Polyglot({locale: locale})

getPolyglotPhrasesFromDatabase(locale)

function getPolyglotPhrasesFromDatabase (locale) {
  const rootRef = firebase.database().ref()
  const config = rootRef.child('crescendo').child('translationKeys').child(locale)
  config.on('value', dataSnapshot => {
    const phrases = dataSnapshot.val()
    if (phrases) {
      polyglot.extend(phrases)
      polyglot.extend({
        'staticFields': {
          'numMonths': `%{smart_count}  ${phrases.staticFields['commonFields'].month} |||| %{smart_count}  ${phrases.staticFields['commonFields'].months} `,
          'numWeeks': `%{smart_count}  ${phrases.staticFields['commonFields'].week} |||| %{smart_count}  ${phrases.staticFields['commonFields'].weeks} `,
          'numDays': `%{smart_count}  ${phrases.staticFields['commonFields'].day} |||| %{smart_count}  ${phrases.staticFields['commonFields'].days} `,
          'numYears': `%{smart_count}  ${phrases.staticFields['commonFields'].year} |||| %{smart_count}  ${phrases.staticFields['commonFields'].years} `
        }
      })
    }
  })
}

export function changePolyglotValues (newValue) {
  polyglot = newValue
  return polyglot
  // console.log(polyglot)
}

export function changeMomentLocale (locale) {
  if (locale === 'it') {
    moment.defineLocale('it', LOCALE_IT_IT)
  } else if (locale === 'pt') {
    moment.defineLocale('pt', LOCALE_PT_PT)
  } else if (locale === 'es') {
    moment.defineLocale('es', LOCALE_ES_ES)
  } else if (locale === 'fr') {
    moment.defineLocale('fr', LOCALE_FR_FR)
  } else {
    moment.defineLocale('en', LOCALE_EN_GB)
  }
}

export { polyglot, locale }

changeMomentLocale(locale)

BigCalendar.momentLocalizer(moment)

// Initialize another app with a different config
// Must be initialized after polyglot configuration finishes work

let dataApp = firebase.initializeApp(data, 'data')

const dataAppDatabase = dataApp.database()
const dataAppStorage = dataApp.storage()

let patientsDatabase = dataApp.database().ref().child('crescendo').child('patientsByCountry').child(locale)

export function changePatientsDatabase (locale) {
  patientsDatabase = dataApp.database().ref().child('crescendo').child('patientsByCountry').child(locale)
}

export { dataAppDatabase, dataAppStorage, patientsDatabase }

ReactDOM.render(<App />, document.getElementById('root'))
// registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js